module.exports = __webpack_public_path__ + "static/media/page-logo-2.f53198a0.png";